export default [
    {
        path: '/site-inspection-scheduler',
        name: 'SiteInspectionScheduler',
        meta: {
            requiresAuth: true,
            title: 'Site inspection schedule',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/siteInspectionScheduler/SchedulerIndex.vue'),
            agent: () => import('@views/siteInspectionScheduler/SchedulerIndex.vue'),
        },
    },
];
